<template>
  <div>
    <div :id="sectionGroup + '-widget'" class="row">
      <div class="table-responsive">
        <table
          v-if="currentSupplierList.length > 0"
          class="
            js-table-checkable
            table table-hover table-vcenter
            js-table-checkable-enabled
          "
        >
          <thead>
            <tr>
              <th class="text-center" style="width: 70px"></th>
              <th class="d-sm-table-cell">
                {{
                  translate
                    ? translate[lang]
                      ? translate[lang]["package"]
                      : ""
                    : ""
                }}
              </th>
              <th width="40%" class="text-right d-sm-table-cell">
                {{
                  enums[sectionGroup]
                    ? enums[sectionGroup].estimated
                      ? translate[lang]["estimatedpermonth"]
                      : translate[lang]["permonth"]
                    : translate[lang]["permonth"]
                }}
              </th>
            </tr>
          </thead>
          <transition-group name="flip-list" tag="tbody">
            <tr
              v-for="key in limit"
              :key="currentSupplierList[key - 1].id"
              v-if="currentSupplierList[key - 1]"
              @click="setSupplier(currentSupplierList[key - 1])"
            >
              <td class="text-center">
                <div
                  class="
                    custom-control custom-checkbox custom-control-primary
                    d-inline-block
                  "
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="'sup' + currentSupplierList[key - 1].id"
                    :name="
                      'products[' +
                      sectionGroup +
                      '][proposition][' +
                      currentSupplierList[key - 1].id +
                      ']'
                    "
                    :value="currentSupplierList[key - 1].id"
                    :checked="currentSupplierList[key - 1].status"
                    @click="setSupplier(currentSupplierList[key - 1])"
                  />
                  <label
                    class="custom-control-label"
                    :for="'sup' + currentSupplierList[key - 1].id"
                  ></label>
                </div>
              </td>
              <td class="d-sm-table-cell">
                <a
                  style="z-index: 110"
                  class="more"
                  data-toggle="modal"
                  data-target="#computedInfo"
                  @click="openModal(currentSupplierList[key - 1], $event)"
                  v-if="enums[sectionGroup] ? enums[sectionGroup].info : false"
                >
                  <i style="color: #0665d0" class="fas fa-info-circle fa"></i>
                </a>
                {{
                  parseJSONSupplierName(currentSupplierList[key - 1].name, lang)
                }}
              </td>
              <td
                width="20%"
                class="text-right d-sm-table-cell"
                style="white-space: nowrap"
              >
                €
                {{
                  currentSupplierList[key - 1].yearly
                    ? formatPrice(currentSupplierList[key - 1].yearly)
                    : formatPrice("0.00")
                }}
              </td>
            </tr>
          </transition-group>
        </table>
      </div>
      <button
        type="button"
        v-if="limit < currentSupplierList.length"
        class="btn btn-light btn-block"
        @click="loadMore()"
      >
        {{ translate[lang]["loadmore"] }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import "./flipList.scss";
export default {
  name: "NewSupplierWidget",
  props: ["index", "sectionGroup", "sectionId", "sectionType", "defaultItem"],
  data() {
    return {
      limit: 6,
    };
  },
  computed: {
    ...mapState({
      submitData: (state) => state.forms.SubmitData,
    }),
    currentProduct() {
      return this.form.data.fields[this.index].filter(
        (x) => x.id == this.sectionId && x.type == this.sectionType
      )[0];
    },
    currentSupplierList() {
      let supplierList = [];
      supplierList = this.setShow(this.currentProduct.suppliers);

      this.clearValues();
      supplierList.forEach((item) => {
        this.setValues(item, item.status); // TODO: item.status for trigger to computed
      });
      this.setTotalPrice();

      return supplierList;
    },
    countStatusTrue() {
      return this.currentSupplierList.filter((a) => a.status == 1).length;
    },
    currentOverview() {
      return this.overview.filter((a) => a.group == this.sectionGroup)[0];
    },
    currentRates() {
      return this.currentOverview.rates;
    },
  },
  methods: {
    ...mapMutations({
      setModalContentComputed: "forms/SET_MODAL_CONTENT_COMPUTED",
    }),
    openModal(item) {
      if (this.currentRates && this.currentRates.length > 0) {
        this.setModalContentComputed({
          title:
            this.currentRates.filter((a) => a.proposition_id == item.id)
              .length > 0
              ? this.currentRates.filter((a) => a.proposition_id == item.id)[0]
                  .title
                ? this.currentRates.filter(
                    (a) => a.proposition_id == item.id
                  )[0].title[this.lang]
                : null
              : null,
          description:
            this.currentRates.filter((a) => a.proposition_id == item.id)
              .length > 0
              ? this.currentRates.filter((a) => a.proposition_id == item.id)[0]
                  .description
                ? this.currentRates.filter(
                    (a) => a.proposition_id == item.id
                  )[0].description[this.lang]
                : null
              : null,
        });
        // e.stopPropagation();
        // window.$("#computedInfo").modal();
      }
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    },
    loadMore() {
      this.scrollAnimate("#" + this.sectionGroup + "-widget");
      let show =
        this.currentSupplierList.length - this.limit > 6
          ? 6
          : this.currentSupplierList.length - this.limit;
      this.limit += show;
    },
    setStatus(proposition) {
      if (proposition.status == 1) {
        this.currentSupplierList.filter(
          (a) => a.id == proposition.id
        )[0].status = 0;
      } else {
        this.currentSupplierList.filter(
          (a) => a.id == proposition.id
        )[0].status = 1;
      }
    },
    setSupplier(proposition) {
      this.setStatus(proposition);
    },
    clearValues() {
      this.currentOverview.packages = [];
    },
    setValues(proposition, status) {
      let rate = this.currentRates.filter(
        (a) => a.proposition_id == proposition.id
      )[0]
        ? this.currentRates.filter((a) => a.proposition_id == proposition.id)[0]
            .rate
        : 0;
      this.setRate(proposition, rate);

      if (status == 1) {
        this.setPackage(proposition);
      }
    },
    setRate(proposition, rate) {
      proposition.yearly = rate;
    },
    setPackage(proposition) {
      this.currentOverview.packages.push(proposition);
    },
    setShow(proposition) {
      return proposition.filter((x) => x.show === 1);
    },
    setTotalPrice() {
      let packagestotal = 0;
      this.currentOverview.packages.forEach((proposition) => {
        packagestotal += parseFloat(proposition.yearly);
      });

      this.currentOverview.packagestotal = packagestotal;
      this.currentOverview.yearly = packagestotal * 12;
    },
  },
};
</script>

<style lang="scss"></style>
